import { render } from "./frequentlyAskedQuestions.vue?vue&type=template&id=6f3bddbd"
import script from "./frequentlyAskedQuestions.vue?vue&type=script&lang=js"
export * from "./frequentlyAskedQuestions.vue?vue&type=script&lang=js"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__